const EVENT_COMMENT = 'event-comment';
const commentEventTrigger = () => {
	document.querySelectorAll('.add-comment-grid-form, .js-comment-product')
      .forEach(form => form.addEventListener('submit', () => {
				const event = new CustomEvent(EVENT_COMMENT);
				document.dispatchEvent(event);
			}));
};

export {EVENT_COMMENT, commentEventTrigger};